<template>
  <div class="radar-slot">
    <div class="radar-title">
      {{ title }}
    </div>
    <div class="radar-canvas-wrap">
      <radar-chart
        v-if="chartData"
        :chart-data="chartData"
        :options="options"
      />
    </div>
  </div>
</template>

<script>
import { RadarChart } from 'vue-chart-3'
import { Chart, registerables } from 'chart.js'
import { getRadar } from '../api'

Chart.register(...registerables)

export default {
  components: { RadarChart },

  props: {
    player: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    // The active chat's data/knowledge org — see SourcesPanel.vue's `org` prop.
    org: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      chartData: null,
      options: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: { label: item => ` stanine ${item.parsed.r} / 9` }
          }
        },
        scales: {
          r: {
            min: 0,
            max: 9,
            ticks: {
              color: '#9ca3af',
              backdropColor: 'transparent',
              stepSize: 3,
              showLabelBackdrop: false
            },
            angleLines: { color: 'rgba(20,22,26,0.10)' },
            grid: { color: 'rgba(20,22,26,0.10)' },
            pointLabels: { color: '#374151', font: { size: 9 } }
          }
        }
      }
    }
  },

  async mounted () {
    try {
      const { data } = await getRadar(this.player, this.org)
      this.chartData = {
        labels: data.labels,
        datasets: [
          {
            label: data.player,
            data: data.stanines,
            backgroundColor: 'rgba(138,106,63,0.16)',
            borderColor: '#8A6A3F',
            borderWidth: 2,
            pointBackgroundColor: '#8A6A3F',
            pointBorderColor: '#fff',
            pointRadius: 3
          }
        ]
      }
    } catch (err) {
      console.error('Radar render failed', err)
    }
  }
}
</script>
